export default __webpack_public_path__ + "static/media/img3.08350a9a.png";